module.exports = __webpack_public_path__ + "static/media/fellowships.be71a5fb.png";